export default {
  mutateDefaultLanguage: (state, payload) => {
    state.defaultLanguage = payload;
  },

  mutateNavDrawer: state => {
    state.navDrawerOpen = !state.navDrawerOpen;
  },

  mutateProfileImpersonating: (state, payload) => {
    state.impersonating = payload;
  }
};
